import { captureException } from '@sentry/react';

export function createAndCaptureError(error: Error) {
  const eventId = captureException(error);
  console.info(`${error.message}; Sentry Trace ID: ${eventId}`);
  return {
    error,
    eventId,
  };
}
